<div class="header-item" [ngClass]="{ 'no-ellipsis': noEllipsis() }">
  @if (label()) {
    <div class="header-item__title-wrapper" [matTooltip]="headerTooltip()">
      @if (icon()) {
        <mat-icon class="header-item__icon">
          {{ icon() }}
        </mat-icon>
      }
      <div class="header-item__title">{{ label() }}</div>
    </div>
  }
  <div
    class="header-item__value"
    (click)="onClickValue()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [matTooltip]="hover() || value()"
    [ngClass]="{ 'no-ellipsis': noEllipsis() }"
    (keyup)="onKeyup($event)"
    [attr.data-testid]="'header-item-' + label()"
  >
    @if (value() !== undefined && value() !== null && value() !== '') {
      <div class="header-item__item-value">{{ value() }}</div>
    } @else {
      <div class="header-item__empty-value">{{ placeholderName }}</div>
    }
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayViewportMargin]="16"
    [cdkConnectedOverlayPush]="true"
    (backdropClick)="onClose()"
  >
    <mat-card class="header-item__card">
      <div class="header-item__close-row small-icon-button-wrapper">
        <button mat-icon-button (click)="onClose()" [attr.data-testid]="'header-item-close-button'">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-card-content [ngClass]="{ 'header-item__card--no-padding': noPadding() }">
        <div class="header-item__wrapper">
          <ng-content></ng-content>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
</div>
